var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09601 3.90054e-05H11.7641C12.7715 3.90054e-05 13.6593 0.490998 14.2246 1.23837H5.57267C3.18324 1.23837 1.23844 3.18262 1.23844 5.5726V10.5097C0.491071 9.94375 0.000113487 9.05583 0.000113487 8.04917L-4.00543e-05 3.09594C-4.00543e-05 1.38891 1.38883 0 3.0959 0L3.09601 3.90054e-05Z",
    fill: "#001EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57294 2.47648H15.4794C17.1864 2.47648 18.5752 3.86519 18.5752 5.57226V11.7639C18.5752 13.4709 17.1865 14.8597 15.4794 14.8597H14.8603V18.8309L10.8891 14.8597H5.57287C3.86584 14.8597 2.47708 13.471 2.47708 11.7639L2.47693 5.57226C2.47693 3.86523 3.8658 2.47632 5.57287 2.47632L5.57294 2.47648ZM13.622 9.28752H14.8603V8.04919H13.622V9.28752ZM9.90698 9.28752H11.1453V8.04919H9.90698V9.28752ZM6.19195 9.28752H7.43028V8.04919H6.19195V9.28752Z",
    fill: "#001EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic);
export default __webpack_public_path__ + "static/media/topic.903074295fd557b7b9c1231b4ee3788d.svg";
export { ForwardRef as ReactComponent };